import ParagraphPrimary from 'components/ui/Paragraphs/ParagraphPrimary';
import * as React from 'react';
import { connect } from 'react-redux';
import { fetchConfig } from 'store/config/configActions';
import { translate } from 'utils/translateUtil';

import ErrorLayout from './ErrorLayout';

// import SVGIllustrationGeneralError from 'components/svg/IllustrationGeneralError';
// import ParagraphSecondary from 'components/ui/Paragraphs/ParagraphSecondary';
// import { Link } from 'components/text';
// import { Button } from 'components/buttons';
const SelfAuthError = (props: any) => {
    React.useEffect(props.fetchConfig, []);
    return (
        <ErrorLayout
            headline={translate('globals.errorPage.internal.title')}
            description={
                <>
                    <ParagraphPrimary>
                        {translate(
                            'globals.errorPage.internal.descriptionPartialOne'
                        )}<br /><br />
                        {translate(
                            'globals.errorPage.internal.descriptionPartialTwo'
                        )}<br /><br />
                        {translate(
                            'globals.errorPage.internal.descriptionPartialThree'
                        )}<br /><br />
                        {translate(
                            'globals.errorPage.internal.descriptionPartialFour'
                        )}
                        <strong>{translate('globals.errorPage.internal.hotline')}</strong>
                        {translate(
                            'globals.errorPage.internal.descriptionPartialFive'
                        )}<br /><br />
                        {translate(
                            'globals.errorPage.internal.goodbye'
                        )}<br />
                        {translate(
                            'globals.errorPage.internal.signature'
                        )}
                    </ParagraphPrimary>
                </>
            }
        />
    );
};
const mapDispatchToProps = {
    fetchConfig
}
const mapStateToProps = (state: any) => (
    { config: state.config }
)
export default connect(mapStateToProps, mapDispatchToProps)(SelfAuthError as any);
